import { Alert, Box, Button, Typography } from "@mui/material";
import { buildActivationUrl } from "./activationUrl";

interface EnableFormsStepProps {
  shop: string | undefined;
}

// Shopify no longer loads our forms through a script tag. The merchant switches on the tinyAlbert app embed once in
// the theme editor. The link opens in a new tab, which also works when the app runs embedded in Shopify admin.
function EnableFormsStep({ shop }: EnableFormsStepProps) {
  const activationUrl = buildActivationUrl(
    shop,
    import.meta.env.VITE_APP_SHOPIFY_CLIENT_ID
  );

  if (!activationUrl) {
    return null;
  }

  return (
    <Alert
      severity="info"
      variant="outlined"
      sx={{
        mb: 5,
        p: "5px",
        alignItems: "center",
        "& .MuiAlert-message": { py: 0 },
        "& .MuiAlert-action": { pl: 3, mr: 0 },
      }}
      id="enable-forms-step"
      action={
        <Button
          variant="contained"
          href={activationUrl}
          target="_blank"
          rel="noopener noreferrer"
          id="enable-forms-step-button"
        >
          Enable tinyAlbert forms
        </Button>
      }
    >
      <Typography variant="p1" component="div" fontWeight={600} mb={1}>
        Show your forms on your store
      </Typography>
      <Box
        component="ol"
        sx={{
          m: 0,
          pl: 0,
          listStylePosition: "inside",
          "& li + li": { mt: 0.5 },
        }}
      >
        <Typography variant="p2" component="li">
          Click <b>Enable tinyAlbert forms</b>. Your theme editor opens in a new
          tab with <b>tinyAlbert forms</b> switched on.
        </Typography>
        <Typography variant="p2" component="li">
          Click <b>Save</b> in the top right corner of the theme editor.
        </Typography>
      </Box>
      <Typography variant="p2" component="div" color="grey.80" mt={1.5}>
        You only need to do this once. If you change your theme, do it again for
        the new theme.
      </Typography>
    </Alert>
  );
}

export default EnableFormsStep;
